angular.module('dpw.services').factory('imageService', ['$q', function ($q) {

    var errorMsg = {
        notSquare: RCDPW.Lang.DynamicAppGallery['IS_NOT_SQUARE'],
        notImage: RCDPW.Lang.DynamicAppGallery['IS_NOT_A_IMAGE']
    };

    return {
        isSquare: isSquare,
        isImage: isImage
    }

    function isSquare(file) {
        return $q(function (resolve, reject) {
            if (file instanceof File) {
                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function (e) {
                    detectSquare(e.target.result)
                        .then(resolve)
                        .catch(function (err) {
                            reject(err);
                        });
                };
            } else {
                detectSquare(file)
                    .then(resolve)
                    .catch(function (err) {
                        reject(err);
                    });
            }
        });
    }

    function isImage(file) {
        return $q(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function (e) {
                var image = new Image();
                image.onload = function () {
                    resolve();
                };

                image.onerror = function () {
                    reject(errorMsg.notImage);
                };

                image.src = e.target.result;
            };
        });
    }

    function detectSquare(src) {
        return $q(function (resolve, reject) {
            var image = new Image();
            image.onload = function () {
                var isValid = image.height === image.width;
                if (isValid) {
                    resolve();
                } else {
                    reject(errorMsg.notSquare);
                }
            };

            image.src = src;
        });
    }
}]);
